import { render, staticRenderFns } from "./three-d-explain-desc.vue?vue&type=template&id=313d22dc&scoped=true&"
import script from "./three-d-explain-desc.vue?vue&type=script&lang=js&"
export * from "./three-d-explain-desc.vue?vue&type=script&lang=js&"
import style0 from "./three-d-explain-desc.vue?vue&type=style&index=0&id=313d22dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313d22dc",
  null
  
)

export default component.exports